/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import lock from "../picture/lock.png";

const PageAccessDenied = (props) => {
    const { setOutletContext } = useOutletContext();        // setOutletContext for set attribute value from route children element

    useEffect(() => {
        document.title = "Access denied";               // set Document title
        setOutletContext(props);                            // set attribute from route children element
    }, []);

    return (
        <>
            <main style={{ marginTop: '10%' }}>
                <div className="textAlign-center">
                    <p>
                        <img
                            src={lock}
                            alt=""
                            loading="lazy"

                        />
                    </p>
                    <p className='font30'>403</p>
                    <p className="f-bold font30">Access denied</p>
                    <p>ບໍ່ສາມາດເຂົ້າເຖິງໄດ້.</p>
                </div>
            </main>
        </>
    )
}

export default PageAccessDenied